//--------------- IMPORTAÇÕES ---------------//
import api from "../../../shared/services/api";
import { toast } from "react-toastify";


//--------------- EXPORTAÇÃO DO SERVIÇO LOAD COMPANIES ---------------//
// Responsável por requisitar à API as empresas existentes ao usuário
export default async function createGroupService(name) {
    try {
        if (!name.trim()) { 
            toast.warn("Informe um nome de grupo");
            return null;
        }
        const response = await api.post(`/grupos-produtos`, { nome: name });
        toast.success("Grupo criado com sucesso");
        return response;
    } catch (error) {
        toast.error("Erro ao criar grupo");
        return null;
    }
}